import type { PrV2MarkerDetectedAgent } from '@/lib/pr-v2/types';

const UNKNOWN_MODEL_VALUES = new Set(['unknown', 'default', 'null', 'undefined', 'n/a', 'na', '']);

export function isUnknownModel(model: string): boolean {
  return UNKNOWN_MODEL_VALUES.has(model.trim().toLowerCase());
}

/**
 * Marker-detected agents that git-ai did not already measure. An agent git-ai
 * knows about keeps its measured row and gets no second, count-less one.
 */
export function selectMarkerOnlyAgents(
  gitAiTools: { tool: string }[],
  detectedAgents: PrV2MarkerDetectedAgent[],
): PrV2MarkerDetectedAgent[] {
  const measuredTools = new Set(gitAiTools.map((entry) => entry.tool.toLowerCase()));
  return detectedAgents.filter((agent) => !measuredTools.has(agent.agentId.toLowerCase()));
}
